import { Component, Input, OnInit } from '@angular/core';
import { CarouselSlide } from '../../models/carousel-slider-interface';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  @Input() slides: CarouselSlide[];
  @Input() currentSlide: number | null = 0;

  constructor() {}

  ngOnInit(): void {}

  onPreviousClick(): void {
    const previous = this.currentSlide - 1;
    this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
  }

  onNextClick(): void {
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.slides.length ? 0 : next;
  }
}
